<template>
  <div class="meun">
    <div @click="handleList">隐藏/显示列表</div>
    <div @click="digfill">挖填方分析</div>
    <div @click="startScrollCompare">卷帘对比</div>
    <div @click="measureDistanceHeight">点对点距离量算</div>
    <div @click="measureArea">面积量算</div>
  </div>
</template>
<script>
import MeasureThings from "../../mapfunction/MeasureThings.js";

export default {
  name: "meun",
  data() {
    return {
      showlist: true,
      msd: false,
    };
  },
  methods: {
    digfill() {
      if (this.showcompare) {
        return;
      }
      this.showcompare = !this.showcompare;
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "barAnimationStart",
        true
      );
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "receiveMsg",
        "单击左键开始标注矩形,挪动鼠标绘制,再次点击结束"
      );
    },
    measureDistanceHeight() {
      if (this.msd) {
        return;
      } else {
        this.msd = true;
        MeasureThings.start();
        map3d_viewer.viewer.mouseHandlerManager.trigger(
          "receiveMsg",
          "点选模型上两点测量"
        );
      }
    },
    measureArea() {
      if (this.msd) {
        return;
      } else {
        this.msd = true;
        MeasureThings.startArea();
        map3d_viewer.viewer.mouseHandlerManager.trigger(
          "receiveMsg",
          "连续点击多个点开始量算,点击最后一个点结束量算"
        );
      }
    },
    handleList() {
      this.showlist = !this.showlist;
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "showList",
        this.showlist
      );
    },
    startScrollCompare() {
      if (this.showcompare) {
        return;
      }
      this.showlist = false;
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "showList",
        this.showlist
      );
      map3d_viewer.viewer.mouseHandlerManager.trigger("setTileseShow", false);
      this.showcompare = !this.showcompare;
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "scrollCompareStart",
        this.showcompare
      );
    },
  },
  mounted() {
    map3d_viewer.viewer.mouseHandlerManager.listen(
      "cleanMDEntities",
      (config) => {
        this.msd = false;
        map3d_viewer.viewer.mouseHandlerManager.trigger("receiveMsg", null);
      }
    );
    map3d_viewer.viewer.mouseHandlerManager.listen(
      "cleanMAEntities",
      (config) => {
        this.msd = false;
        map3d_viewer.viewer.mouseHandlerManager.trigger("receiveMsg", null);
      }
    );
    map3d_viewer.viewer.mouseHandlerManager.listen("setShow", (config) => {
      this.showcompare = config;
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("showlist", (show) => {
      this.showlist = show;
      map3d_viewer.viewer.mouseHandlerManager.trigger(
        "showList",
        this.showlist
      );
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("compareState", (config) => {
      this.showcompare = config;
    });
  },
};
</script>
<style scoped>
.meun {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  left: 85%;
  top: 3.5%;
  height: 55px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
}
.meun div {
  cursor: pointer;
  margin: 0;
  padding: 0;
  width: 120px;
  color: white;
  margin: 0px;
  text-align: center;
  line-height: 50px;
}
.meun div:hover {
  border-bottom: 1px solid white;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/meun.vue